import { createSlice } from '@reduxjs/toolkit';

import { popupReducer } from './_reducer';
import { popupState } from './_state';

/** Feature Chatbot Slice. */
export const chatbotSlice = createSlice({
  name: 'feature_chatbot',
  initialState: popupState,
  reducers: popupReducer,
});

/** Feature Chatbot Slice Actions. */
export const chatbotSliceActions = chatbotSlice.actions;

/** Feature Chatbot Slice Selectors. */
export const chatbotSliceSelectors = chatbotSlice.selectors;
